module.exports = __webpack_public_path__ + "static/media/4pic.49a19e4b.png";